var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-json-excel',{staticStyle:{"width":"100%"},attrs:{"data":_vm.data,"fields":_vm.fields,"name":_vm.name,"title":_vm.title,"beforeGenerate":_vm.beforeGenerate}},[_vm._v("\n  "+_vm._s(_vm.$gettext('Export'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }